import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { change_MyData,check_anthScreen } from '../store';
import AgentPinPanel from './AgentPinPanel';
export default function AgentPinManage(){
    const dispatch=useDispatch(),navigate=useNavigate();
    return <main className="agent-pin-manage-page"><div className="pin-dialog-shell"><AgentPinPanel onExit={()=>navigate(-1)} onSessionExpired={()=>{dispatch(change_MyData(null));dispatch(check_anthScreen([]));navigate("/login",{replace:true,state:{forcePasswordLogin:true,sessionExpired:true}});}} onRegistered={()=>{dispatch(change_MyData(null));dispatch(check_anthScreen([]));navigate('/login',{replace:true,state:{pinRegistered:true}});}}/></div></main>;
}
